import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
import { PhoneCall, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].finalCta;
  const containerRef = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [-100, 100]);
  return <section className="relative py-32 flex items-center justify-center overflow-hidden" ref={containerRef} data-id="element-119">
      {/* Background Image with Dramatic Parallax */}
      <motion.div className="absolute inset-0 z-0" style={{
      y,
      scale: 1.1
    }} // Scale prevents edges showing during parallax
    data-id="element-120">
        <img src="https://cdn.magicpatterns.com/uploads/kiRPZ67DCoPow89rjDSeY7/hf_20260430_172717_e667c99f-785e-4196-a80e-61f75430d1ed.png" alt="Happy Family Move" className="w-full h-full object-cover object-center" data-id="element-121" />
        <div className="absolute inset-0 bg-gradient-to-t from-mf-black via-mf-black/70 to-mf-black/90" data-id="element-122"></div>
      </motion.div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-123">
        {/* Glassmorphism Card Container */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 20
      }} className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-[40px] p-10 md:p-16 text-center shadow-2xl" data-id="element-124">
          <motion.h2 initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1,
          type: 'spring',
          stiffness: 100
        }} className="text-5xl md:text-7xl font-condensed font-black text-white uppercase tracking-tight mb-6 drop-shadow-lg" data-id="element-125">
            {text.title}
          </motion.h2>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-3xl text-gray-200 font-medium mb-12 max-w-2xl mx-auto" data-id="element-126">
            {text.sub}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          type: 'spring',
          stiffness: 100
        }} className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-127">
            <a href="#booking" className="group relative flex items-center justify-center px-10 py-5 font-condensed font-bold text-2xl text-mf-black uppercase tracking-widest bg-mf-yellow rounded-2xl shadow-[0_0_30px_rgba(255,193,7,0.4)] hover:shadow-[0_0_50px_rgba(255,193,7,0.6)] transition-all duration-300 transform hover:-translate-y-1 overflow-hidden" data-id="element-128">
              {/* Animated gradient border effect */}
              <div className="absolute inset-0 border-2 border-white/50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-129"></div>
              <span className="relative z-10 flex items-center" data-id="element-130">
                {text.primaryBtn}
                <ArrowRight className="ml-3 group-hover:translate-x-2 transition-transform duration-300" size={28} data-id="element-131" />
              </span>
            </a>

            <a href="tel:+18134768935" className="flex items-center justify-center px-10 py-5 font-condensed font-bold text-2xl text-white uppercase tracking-widest bg-white/10 backdrop-blur-md border-2 border-white/30 hover:bg-white/20 hover:border-white rounded-2xl transition-all duration-300 transform hover:-translate-y-1" data-id="element-132">
              <PhoneCall className="mr-3" size={28} data-id="element-133" />
              {text.secondaryBtn}
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}